import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import _403 from '@components/403/403.vue';
import _404 from '@components/404/404.vue';
import _about from '@components/about/about';
import _index from '@components/index/Index'
import _common from '@js/common';
import _config from '@js/config';


export default new Router({
    //   mode:"history",
    routes: [
        {
            path: '/',
            redirect: '/users/list'
        },
        {
            path: '/index',
            component: function (resolve, reject) {
                require.ensure('@components/index/Index.vue', function () {
                    var component = require('@components/index/Index.vue');
                    resolve(component);
                }, 'index');
            },
            children: [

                //--------------------使用数据相关 begin--------------------//
                {
                    path: '/usestat/dashboard',
                    component: function (resolve, reject) {
                        require.ensure('@components/usestat/Dashboard.vue', function () {
                            var component = require('@components/usestat/Dashboard.vue');
                            resolve(component);
                        }, 'clazzlist');
                    }
                },
                //--------------------使用数据相关 end----------------------//

                //--------------------使用排行相关 begin--------------------//
                {
                    path: '/rank/weekpaper',
                    component: function (resolve, reject) {
                        require.ensure('@components/rank/Weekpaper.vue', function () {
                            var component = require('@components/rank/Weekpaper.vue');
                            resolve(component);
                        }, 'clazzlist');
                    }
                },
                {
                    path: '/rank/monthpaper',
                    component: function (resolve, reject) {
                        require.ensure('@components/rank/Monthpaper.vue', function () {
                            var component = require('@components/rank/Monthpaper.vue');
                            resolve(component);
                        }, 'userslist');
                    }
                },
                {
                    path: '/rank/termpaper',
                    component: function (resolve, reject) {
                        require.ensure('@components/rank/Termpaper.vue', function () {
                            var component = require('@components/rank/Termpaper.vue');
                            resolve(component);
                        }, 'reviewlist');
                    }
                },
                {
                    path: '/rank/yearpaper',
                    component: function (resolve, reject) {
                        require.ensure('@components/rank/Yearpaper.vue', function () {
                            var component = require('@components/rank/Yearpaper.vue');
                            resolve(component);
                        }, 'reviewlist');
                    }
                },
                //--------------------使用排行相关 end----------------------//


                //--------------------学校管理相关 begin--------------------//
                {
                    path: '/clazz/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/clazz/List.vue', function () {
                            var component = require('@components/clazz/List.vue');
                            resolve(component);
                        }, 'clazzlist');
                    }
                },
                {
                  path: '/userinfo/userinfo',
                  component: function (resolve, reject) {
                    require.ensure('@components/clazz/List.vue', function () {
                      var component = require('@components/userinfo/Userinfo.vue');
                     resolve(component);
                    }, 'userinfo');
                  }
                },
              {
                path: '/userinfo/question',
                component: function (resolve, reject) {
                  require.ensure('@components/userinfo/Questionnaire.vue', function () {
                    var component = require('@components/userinfo/Questionnaire.vue');
                    resolve(component);
                  }, 'question');
                }
              },
                {
                    path: '/users/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/users/List.vue', function () {
                            var component = require('@components/users/List.vue');
                            resolve(component);
                        }, 'userslist');
                    }
                },
                {
                  path: '/review/list',
                  component: function (resolve, reject) {
                      require.ensure('@components/review/List.vue', function () {
                          var component = require('@components/review/List.vue');
                          resolve(component);
                      }, 'reviewlist');
                  }
              },
                //--------------------学校管理相关 end----------------------//

                //--------------------通知相关 begin----------------------//
                {
                    path: '/notice/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/notice/List.vue', function () {
                            var component = require('@components/notice/List.vue');
                            resolve(component);
                        }, 'noticelist');
                    }
                },
                //--------------------通知相关 end------------------------//


                //--------------------食谱相关 begin----------------------//
                {
                    path: '/recipe/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/recipe/List.vue', function () {
                            var component = require('@components/recipe/List.vue');
                            resolve(component);
                        }, 'recipelist');
                    }
                },
                {
                    path: '/recipe/edit',
                    component: function (resolve, reject) {
                        require.ensure('@components/recipe/Edit.vue', function () {
                            var component = require('@components/recipe/Edit.vue');
                            resolve(component);
                        }, 'recipeEdit');
                    }
                },
                //--------------------食谱相关 end------------------------//

                //--------------------学校活动相关 begin--------------------//

                {
                    path: '/schoolactivity/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/funcs/schoolactivity/List.vue', function () {
                            var component = require('@components/funcs/schoolactivity/List.vue');
                            resolve(component);
                        }, 'schoolactivity_list');
                    }
                },

                {
                    path: '/schoolactivity/summary',
                    component: function (resolve, reject) {
                        require.ensure('@components/funcs/schoolactivity/Summary.vue', function () {
                            var component = require('@components/funcs/schoolactivity/Summary.vue');
                            resolve(component);
                        }, 'schoolactivity_summary');
                    }
                },
                {
                    path: '/schoolactivity/records',
                    component: function (resolve, reject) {
                        require.ensure('@components/funcs/schoolactivity/Records.vue', function () {
                            var component = require('@components/funcs/schoolactivity/Records.vue');
                            resolve(component);
                        }, 'schoolactivity_records');
                    }
                },

                //--------------------学校活动相关 end----------------------//



                //--------------------体温相关 begin----------------------//
                {
                    path: '/tiwen/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/tiwen/list.vue', function () {
                            var component = require('@components/tiwen/list.vue');
                            resolve(component);
                        }, 'tiwenlist');
                    }
                },
                {
                    path: '/tiwen/detail',
                    component: function (resolve, reject) {
                        require.ensure('@components/tiwen/detail.vue', function () {
                            var component = require('@components/tiwen/detail.vue');
                            resolve(component);
                        }, 'tiwendetail');
                    }
                },

                //--------------------体温相关 end------------------------//


                //--------------------请假相关 begin-----------------------//
                {
                    path: '/leave/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/leave/list.vue', function () {
                            var component = require('@components/leave/list.vue');
                            resolve(component);
                        }, 'leavelist');
                    }
                },
                {
                    path: '/leave/classstat',
                    component: function (resolve, reject) {
                        require.ensure('@components/leave/Classstat.vue', function () {
                            var component = require('@components/leave/Classstat.vue');
                            resolve(component);
                        }, 'leaveclassstat');
                    }
                },
                {
                    path: '/leave/healthcheck',
                    component: function (resolve, reject) {
                        require.ensure('@components/leave/Healthcheck.vue', function () {
                            var component = require('@components/leave/Healthcheck.vue');
                            resolve(component);
                        }, 'leavehealthcheck');
                    }
                },
                {
                    path: '/leave/studentstat',
                    component: function (resolve, reject) {
                        require.ensure('@components/leave/Studentstat.vue', function () {
                            var component = require('@components/leave/Studentstat.vue');
                            resolve(component);
                        }, 'leavestudentstat');
                    }
                },
              {
                path: '/leave/settings',
                component: function (resolve, reject) {
                  require.ensure('@components/leave/Setting.vue', function () {
                    var component = require('@components/leave/Setting.vue');
                    resolve(component);
                  }, 'leaveSetting');
                }
              },
              {
                path: '/leave/approve',
                component: function (resolve, reject) {
                  require.ensure('@components/leave/Approve.vue', function () {
                    var component = require('@components/leave/Approve.vue');
                    resolve(component);
                  }, 'leaveApprove');
                }
              },
                //--------------------请假相关 end-------------------------//


                //--------------------微官网相关 begin---------------------//
                /*{
                    path: '/subcription/index',
                    meta: { referrer: 'origin-when-cross-origin' },
                    component: function (resolve, reject) {
                        require.ensure('@components/subcription/index.vue', function () {
                            var component = require('@components/subcription/index.vue');
                            resolve(component);
                        }, 'subcriptionindex');
                    }
                },*/
                //--------------------微官网相关 end-----------------------//

                //--------------------成绩管理相关 begin--------------------//

                {
                    path: '/score/list',
                    component: function (resolve, reject) {
                        require.ensure('@components/score/list.vue', function () {
                            var component = require('@components/score/list.vue');
                            resolve(component);
                        }, 'scorelist');
                    }
                },
                {
                    path: '/score/format',
                    component: function (resolve, reject) {
                        require.ensure('@components/score/format.vue', function () {
                            var component = require('@components/score/format.vue');
                            resolve(component);
                        }, 'scoreformat');
                    }
                },
                {
                    path: '/score/upload',
                    component: function (resolve, reject) {
                        require.ensure('@components/score/upload.vue', function () {
                            var component = require('@components/score/upload.vue');
                            resolve(component);
                        }, 'scoreUpload');
                    }
                },
                {
                  path: '/score/queryscore',
                  component: function (resolve, reject) {
                      require.ensure('@components/score/queryscore.vue', function () {
                          var component = require('@components/score/queryscore.vue');
                          resolve(component);
                      }, 'queryscore');
                  }
                },
                //--------------------成绩管理相关 end----------------------//


                //--------------------应用服务相关 begin--------------------//
                {
                    path: '/service/index',
                    component: function (resolve, reject) {
                        require.ensure('@components/service/index.vue', function () {
                            var component = require('@components/service/index.vue');
                            resolve(component);
                        }, 'serviceindex');
                    }
                },
                {
                    path: '/service/detail',
                    component: function (resolve, reject) {
                        require.ensure('@components/service/detail.vue', function () {
                            var component = require('@components/service/detail.vue');
                            resolve(component);
                        }, 'servicedetail');
                    }
                },
                {
                  path: '/service/saasDetail',
                  component: function (resolve, reject) {
                    require.ensure('@components/service/saasDetail.vue', function () {
                      var component = require('@components/service/saasDetail.vue');
                      resolve(component);
                    }, 'saasdetail');
                  }
                },
                {
                  path: '/service/saasDetail2',
                  component: function (resolve, reject) {
                    require.ensure('@components/service/saasDetail2.vue', function () {
                      var component = require('@components/service/saasDetail2.vue');
                      resolve(component);
                    }, 'saasdetail2');
                  }
                },
                {
                  path: '/service/teaserviceintro',
                  component: function (resolve, reject) {
                    require.ensure('@components/service/Teaserviceintro.vue', function () {
                      var component = require('@components/service/Teaserviceintro.vue');
                      resolve(component);
                    }, 'teaserviceintro');
                  }
                },
                {
                  path: '/service/saasService',
                  component: function (resolve, reject) {
                    require.ensure('@components/service/saasService.vue', function () {
                      var component = require('@components/service/saasService.vue');
                      resolve(component);
                    }, 'saasService');
                  }
                },
                //--------------------应用服务相关 end----------------------//


                //--------------------学校相册相关 begin--------------------//
                {
                    path: '/schoolAlbum/index',
                    component: function (resolve, reject) {
                        require.ensure('@components/schoolAlbum/index.vue', function () {
                            var component = require('@components/schoolAlbum/index.vue');
                            resolve(component);
                        }, 'schoolAlbum');
                    }
                },
                //--------------------学校相册相关 end----------------------//

                //--------------------综合评价相关 begin--------------------//

                {
                    path: '/evaluate/index',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/index.vue', function () {
                            var component = require('@components/evaluate/index.vue');
                            resolve(component);
                        }, 'evaluate');
                    }
                },
                {
                    path: '/evaluate/mange',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/mange.vue', function () {
                            var component = require('@components/evaluate/mange.vue');
                            resolve(component);
                        }, 'evaluatemange');
                    }
                },
                {
                    path: '/evaluate/detail',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/detail.vue', function () {
                            var component = require('@components/evaluate/detail.vue');
                            resolve(component);
                        }, 'evaluate');
                    }
                },
                {
                    path: '/evaluate/classmange',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/mange.vue', function () {
                            var component = require('@components/evaluate/classmange.vue');
                            resolve(component);
                        }, 'evaluateclassmange');
                    }
                },
                {
                    path: '/evaluate/classreviewmanger',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/detail.vue', function () {
                            var component = require('@components/evaluate/classreviewmanger.vue');
                            resolve(component);
                        }, 'classreviewmanger');
                    }
                },
                {
                    path: '/evaluate/classcommentdetail',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/detail.vue', function () {
                            var component = require('@components/evaluate/classcommentdetail.vue');
                            resolve(component);
                        }, 'classcommentdetail');
                    }
                },
                {
                    path: '/evaluate/classexchangelist',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/classexchangelist.vue', function () {
                            var component = require('@components/evaluate/classexchangelist.vue');
                            resolve(component);
                        }, 'classcommentdetail');
                    }
                },
                {
                    path: '/evaluate/statistics',
                    component: function (resolve, reject) {
                        require.ensure('@components/evaluate/statistics.vue', function () {
                            var component = require('@components/evaluate/statistics.vue');
                            resolve(component);
                        }, 'statistics');
                    }
                },
                {
                  path: '/evaluate/classdetail',
                  component: function (resolve, reject) {
                      require.ensure('@components/evaluate/classdetail.vue', function () {
                          var component = require('@components/evaluate/classdetail.vue');
                          resolve(component);
                      }, 'classdetail');
                  }
              },

                //--------------------综合评价相关 end----------------------//


                //--------------------综合评价相关 start----------------------//
                {
                    path: '/cloudprint/introduce',
                    component: function (resolve, reject) {
                        require.ensure('@components/cloudprint/introduce.vue', function () {
                            var component = require('@components/cloudprint/introduce.vue');
                            resolve(component);
                        }, 'cloudprint');
                    }
                },
                //--------------------综合评价相关 end----------------------//

                // 信息采集
                {
                  path: '/infocollect/list',
                  component: function (resolve, reject) {
                      require.ensure('@components/infocollect/list.vue', function () {
                          var component = require('@components/infocollect/list.vue');
                          resolve(component);
                      }, 'infocollect');
                  }
                },
                {
                  path: '/infocollect/send',
                  component: function (resolve, reject) {
                      require.ensure('@components/infocollect/send.vue', function () {
                          var component = require('@components/infocollect/send.vue');
                          resolve(component);
                      }, 'infocollectSend');
                  }
                },
                {
                  path: '/infocollect/statList',
                  component: function (resolve, reject) {
                      require.ensure('@components/infocollect/stat_list.vue', function () {
                          var component = require('@components/infocollect/stat_list.vue');
                          resolve(component);
                      }, 'statList');
                  }
                },
                {
                  path: '/infocollect/statResult',
                  component: function (resolve, reject) {
                      require.ensure('@components/infocollect/stat_result.vue', function () {
                          var component = require('@components/infocollect/stat_result.vue');
                          resolve(component);
                      }, 'statResult');
                  }
                },
                {
                  path: '/infocollect/perview',
                  component: function (resolve, reject) {
                      require.ensure('@components/infocollect/perview.vue', function () {
                          var component = require('@components/infocollect/perview.vue');
                          resolve(component);
                      }, 'infocollectPerview');
                  }
                },

                // 打卡
                {
                  path: '/clock/list',
                  component: function (resolve, reject) {
                      require.ensure('@components/clock/list.vue', function () {
                          var component = require('@components/clock/list.vue');
                          resolve(component);
                      }, 'clock');
                  }
                },
                {
                  path: '/clock/send',
                  component: function (resolve, reject) {
                      require.ensure('@components/clock/send.vue', function () {
                          var component = require('@components/clock/send.vue');
                          resolve(component);
                      }, 'clockSend');
                  }
                },
                {
                  path: '/clock/statList',
                  component: function (resolve, reject) {
                      require.ensure('@components/clock/stat_list.vue', function () {
                          var component = require('@components/clock/stat_list.vue');
                          resolve(component);
                      }, 'statList');
                  }
                },
                {
                  path: '/clock/statResult',
                  component: function (resolve, reject) {
                      require.ensure('@components/clock/stat_result.vue', function () {
                          var component = require('@components/clock/stat_result.vue');
                          resolve(component);
                      }, 'statResult');
                  }
                },
                {
                  path: '/clock/perview',
                  component: function (resolve, reject) {
                      require.ensure('@components/clock/perview.vue', function () {
                          var component = require('@components/clock/perview.vue');
                          resolve(component);
                      }, 'clockPerview');
                  }
                },

                // 大屏
                {
                  path: '/daping/index',
                  component: function (resolve, reject) {
                      require.ensure('@components/daping/index.vue', function () {
                          var component = require('@components/daping/index.vue');
                          resolve(component);
                      }, 'daping');
                  }
                },

                //--------------------班级小精灵 begin--------------------//
                {
                    path: '/xiaojingling/statdata',
                    component: function (resolve, reject) {
                        require.ensure('@components/xiaojingling/Statdata.vue', function () {
                            var component = require('@components/xiaojingling/Statdata.vue');
                            resolve(component);
                        }, 'xiaojinglingstatdata');
                    }
                },
                //--------------------班级小精灵 end----------------------//

                //--------------------学费收缴 begin--------------------//
                {
                    path: '/xuefei',
                    component: function (resolve, reject) {
                        require.ensure('@components/xuefei/xuefei.vue', function () {
                            var component = require('@components/xuefei/xuefei.vue');
                            resolve(component);
                        }, 'xuefei');
                    }
                },
                //--------------------学费收缴 end----------------------//

                //--------------------排选课 begin----------------------//
                {
                    path: '/pxk/index',
                    component: function (resolve, reject) {
                        require.ensure('@components/funcs/pxk/index.vue', function () {
                            var component = require('@components/funcs/pxk/index.vue');
                            resolve(component);
                        }, 'pxk');
                    }
                },
                //--------------------排选课 end----------------------//
            ],
            beforeEnter: function (to, from, next) {
                var accessToken = _common.getAccessToken();
                var schoolCode = _common.getSchoolCode();
                if (!accessToken || !schoolCode) {
                    next('/login');
                } else {
                    next();
                }
            }
        },
        {
            path: '/login',
            component: function (resolve, reject) {
                require.ensure('@components/login/Login.vue', function () {
                    var component = require('@components/login/Login.vue');
                    resolve(component);
                }, 'login');
            }
        },
        {
            path: '/auth/confirm',
            component: function (resolve, reject) {
                require.ensure('@components/auth/index.vue', function () {
                    var component = require('@components/auth/index.vue');
                    resolve(component);
                }, 'authIndex');
            }
        },
        {
            path: '/launchapplet',
            component: function (resolve, reject) {
                require.ensure('@components/qy/Launchapplet.vue', function () {
                    var component = require('@components/qy/Launchapplet.vue');
                    resolve(component);
                }, 'launchapplet');
            }
        },

        //--------------------官网绑定相关 begin--------------------//
        {
            path: '/microwebsite/loginfail',
            component: function (resolve, reject) {
                require.ensure('@components/microwebsite/loginfail.vue', function () {
                    var component = require('@components/microwebsite/loginfail.vue');
                    resolve(component);
                }, 'microwebsitefail');
            }
        },
        {
            path: '/microwebsite/noopen',
            component: function (resolve, reject) {
                require.ensure('@components/microwebsite/noopen.vue', function () {
                    var component = require('@components/microwebsite/noopen.vue');
                    resolve(component);
                }, 'microwebsitenoopen');
            }
        },
        //--------------------官网绑定相关 end----------------------//
        {
            path: '/about',
            name: 'about',
            component: _about
        },
        {
            path: '/403',
            name: '403',
            component: _403
        },
        {
            path: '/(.*)',
            name: 'Other',
            component: _404
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js